const ko = {
  ID_QUICK_CHAT_HELLO: "안녕",
  ID_QUICK_CHAT_COOL: "멋지다",
  ID_QUICK_CHAT_HAHA: "ㅋㅋㅋㅋ",
  ID_QUICK_CHAT_GO_GAME: "게임하자",
  ID_QUICK_CHAT_LATER: "다음에 봐",
  ID_QUICK_CHAT_WAIT: "잠시만",
  ID_QUICK_CHAT_HI: "하이~",
  ID_QUICK_CHAT_LETS_GO: "Let's go!",
  ID_QUICK_CHAT_NICE_TO_MEET_YOU: "반가워",
  ID_QUICK_CHAT_TAKE_A_SELFIE: "같이 사진 찍자!",
};

export default ko;
